import { render, staticRenderFns } from "./ProductListFilters.vue?vue&type=template&id=1a39ad7d&"
import script from "./ProductListFilters.vue?vue&type=script&lang=js&"
export * from "./ProductListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports